{
  "MeasurementsFilterField": {
    "operators": {
      "gt": "Większy niż",
      "eq": "Równy",
      "lt": "Mniejszy niż"
    },
    "units": {
      "cm_long": "Metryczny (cm)",
      "cm": "cm",
      "in_long": "Imperialny (in)",
      "in": "in",
      "m_long": "Metryczny (m)",
      "m": "m",
      "ft_long": "Imperialny (ft)",
      "ft": "ft"
    }
  }
}
